// Manages last 4 visited stations in localStorage
const KEY = 'cw_last_stations'
const MAX = 4

export function getLastStations() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || '[]')
  } catch {
    return []
  }
}

export function addLastStation(station) {
  const list = getLastStations().filter(s => s.gh_id !== station.gh_id)
  list.unshift({ gh_id: station.gh_id, name: station.name })
  localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)))
}